import scroll from 'scroll-into-view';
const scrollIntoView = (target: HTMLElement, settings?: __ScrollIntoView.Settings, callback?: __ScrollIntoView.Callback, useNativeScrolling: boolean = false) => {
	const rect = target.getBoundingClientRect();
	if (useNativeScrolling)
		target.scrollIntoView({ behavior: 'smooth' });
	else if (rect.top < 0 || rect.bottom > (window.innerHeight || document.documentElement.clientHeight))
		scroll(target, settings, callback);
};
export default scrollIntoView;